import type { PayloadAction } from '@reduxjs/toolkit';
import { createSelector, createSlice } from '@reduxjs/toolkit';
import { Source } from '@scenario/models/source.model';
import { RootState } from '@store/create-store';

export interface SourcesState {
  sources: Source[];
  isFetching: boolean;
  error?: string;
}

const initialState: SourcesState = {
  sources: [],
  isFetching: false,
};

export const sourcesSlice = createSlice({
  name: 'sources',
  initialState,
  reducers: {
    retrieveSources: state => {
      state.isFetching = true;
    },
    retrieveSourcesSuccess: (state, action: PayloadAction<Source[]>) => {
      state.sources = [...action.payload].sort((a, b) => a.name.localeCompare(b.name));
      state.isFetching = false;
    },
    retrieveSourcesFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isFetching = false;
    },
  },
});

export type SourcesViewModel = {
  sources: Source[];
  isFetching: boolean;
  error?: string;
};

export const selectSourcesViewModel = createSelector(
  (state: RootState) => state,
  (state): SourcesViewModel => ({
    sources: state.sources.sources,
    isFetching: state.sources.isFetching,
    error: state.sources.error,
  }),
);
export const { retrieveSources, retrieveSourcesSuccess, retrieveSourcesFailure } =
  sourcesSlice.actions;

export default sourcesSlice.reducer;
